// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const FINISH_BLOCK_TRANSFER = 'finishblocktransfer'